import React, {useEffect, useMemo, useState} from 'react';
import {lang, langSiteDir} from '../../common/baseData';
import BrandCategoryWithProducts from './BrandCategoryWithProducts';
import BrandCategoryWithoutProducts from './BrandCategoryWithoutProducts';

function BrandCategorySections({items = [], messages = {}}) {
  function getMessage (code) {
    return messages.hasOwnProperty(code) ? messages[code] : 'Lang message not defined';
  }

  const productSources = useMemo(() => (
    items
      .filter(item => item.showItems && item.productSource?.sectionId)
      .map(item => item.productSource)
  ), [items]);
  const [productsBySection, setProductsBySection] = useState({});
  const [loading, setLoading] = useState(productSources.length > 0);

  useEffect(() => {
    if (productSources.length === 0) {
      setLoading(false);
      return undefined;
    }

    const controller = new AbortController();
    const params = new URLSearchParams({
      sources: JSON.stringify(productSources),
      lang,
      siteDir: langSiteDir,
      currentPath: window.location.pathname,
    });

    setLoading(true);

    fetch(`/local/components/v2/brand.product.list/ajax.php?${params.toString()}`, {
      credentials: 'same-origin',
      signal: controller.signal,
    })
      .then(response => {
        if (!response.ok) throw new Error(`Brand products request failed with status ${response.status}`);
        return response.json();
      })
      .then(data => {
        if (data && !data.error && data.items && typeof data.items === 'object') {
          setProductsBySection(data.items);
        }
        setLoading(false);
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          console.error(error);
          setLoading(false);
        }
      });

    return () => controller.abort();
  }, [productSources]);

  if (items.length === 0) {
    return null;
  }

  const productBlocks = items.filter(block => block.showItems);
  const contentBlocks = items.filter(block => !block.showItems);

  return (
    <>
      {productBlocks.map(block => (
        <BrandCategoryWithProducts
          key={`brand-category-${block.id}`}
          block={block}
          products={productsBySection[String(block.id)] || []}
          loading={loading}
          getMessage={getMessage}
        />
      ))}

      <BrandCategoryWithoutProducts
        items={contentBlocks}
        getMessage={getMessage}
      />
    </>
  );
}

export default BrandCategorySections;